import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import TransportationEoL43Header from "./Header";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
import Flow43_1 from "./Flow43_1";
import Flow43_2 from "./Flow43_2";
import Flow43_3 from "./Flow43_3";
import Flow43_4 from "./Flow43_4";

const ProdTransportationEoL43Components = ({ productId }) => {
  const { t } = useTranslation();
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="transportation-eol-43-container" id="transportation-eol-43-id">
      <TransportationEoL43Header productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="transportation-eol-43-content">
          {/* Flow 43.1 */}
          <Flow43_1 productId={productId} />

          {/* Flow 43.2 */}
          <Flow43_2 productId={productId} />

          {/* Flow 43.3 */}
          <Flow43_3 productId={productId} />

          {/* Flow 43.4 */}
          <Flow43_4 productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdTransportationEoL43Components;

